module.exports = __webpack_public_path__ + "static/15-e75e740ed74e223831f15179031a4def.jpg";